import script from "./AddContentPack.vue?vue&type=script&setup=true&lang=js"
export * from "./AddContentPack.vue?vue&type=script&setup=true&lang=js"

import "./AddContentPack.vue?vue&type=style&index=0&id=5836f093&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5836f093"]])

export default __exports__